import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function SizeGuideButton(props) {
  const { handleClick, productType } = props;
  return (
    <div className={`add-product-sticky__sizeguide add-product-sticky__sizeguide--${productType.toLowerCase()}`}>
      <div className="pdp__size-guide--sticky-view">
        <button type="button" className="pdp__size-guide-wrapper-link js-tracking-size-guide" onClick={handleClick}>
          <span className="pdp__size-guide-label pdp__size-guide-label--sticky-view">
            <FormattedMessage id="products.pdp.sizeGuide.sizeGuide" />
          </span>
          <i className="pdp__size-guide-icon-arrow icon-arrow-cta" />
          <br />
        </button>
      </div>
    </div>
  );
}

SizeGuideButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  productType: PropTypes.string.isRequired,
};

export default SizeGuideButton;
